<apt-content-box>
  <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutAlign="space-between stretch">
    <div fxFlex fxLayout="column" fxLayoutAlign="start start">
      <apt-text-label label="Product/Policy Type">
        <apt-text-waiter [text]="product"></apt-text-waiter>
      </apt-text-label>
    </div>

    <div fxFlex fxLayout="column" fxLayoutAlign="start start">
      <apt-text-label label="Insurance Company">
        <apt-text-waiter [text]="company"></apt-text-waiter>
      </apt-text-label>
    </div>
  </div>
</apt-content-box>
